interface IconChoiceCardProps {
  /** 淺色版圖示路徑；已選時自動換成同名的 `--on` 深色版。 */
  icon: string;
  title: string;
  /** 第二行說明；付款方式多數只有品牌名，沒有副標。 */
  desc?: string;
  active: boolean;
  disabled?: boolean;
  testId: string;
  onClick: () => void;
}

/**
 * 圖示 + 文字的選項卡 — 設計稿的取票、發票與付款方式共用同一種形制。
 *
 * 圖示有淺／深兩個色版：設計稿裡白底卡上的圖示以深藍為主、深藍卡上以金色或白色
 * 為主，只用一版會在其中一種底色上看不見。深色版是同名加 `--on`，由這裡換掉，
 * 呼叫端只給淺色版路徑。
 */
export function IconChoiceCard({
  icon,
  title,
  desc,
  active,
  disabled = false,
  testId,
  onClick,
}: IconChoiceCardProps): JSX.Element {
  const src = active ? icon.replace(/\.png$/, '--on.png') : icon;
  return (
    <button
      type="button"
      data-testid={testId}
      className={`k-payopt${active ? ' k-payopt--active' : ''}`}
      aria-pressed={active}
      disabled={disabled}
      onClick={onClick}
    >
      <img className="k-payopt__icon" src={src} alt="" aria-hidden="true" />
      <span className="k-payopt__text">
        <span className="k-payopt__title">{title}</span>
        {desc !== undefined && <span className="k-payopt__sub">{desc}</span>}
      </span>
    </button>
  );
}
